import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { toStoreGroups } from '@/domain/store-group'

export const useStoreGroups = () => {
  const { t } = useTranslation()
  const user = useAppSelector((s) => s.userApi.getMe.response.user)
  const allLabel = t('selector_component.all')
  const noGroupLabel = t('selector_component.no_group')
  return useMemo(
    () => toStoreGroups(user, allLabel, noGroupLabel),
    [user, allLabel, noGroupLabel]
  )
}
